import React, { useState,useEffect } from 'react';
import frame_back from '../../assests/images/frame_back.png';
import {getByPatientId } from '../../service/action/actioncreator/PatientAction/Patient';
import { useSelector } from "react-redux";

const CommonTab=({model, tabContents, defaultIndex = 0, className,handlePreviousList,patientViewData,structureViewData,viewRoleId})=>{
    const [activeIndex, setActiveIndex] = useState(defaultIndex);

    return(
        <>
            <div className={`common-tabmenu ${className} mt-2`}>
            <div className="tab-header" style={{ backgroundColor: "#007bff", color: "#fff" }}>
                <div className="d-flex ms-4 align-items-center">
                <img src={frame_back} alt="back-btn" className="mb-1 pointer" height="24px" width="24px" onClick={handlePreviousList}/>
               {patientViewData &&
               <>
                <h4 className="ms-2 p-2">{patientViewData?.code}</h4>
                <div className="border-end ms-4 mb-1" style={{ height: "1.5rem", borderWidth: "5px",color:'black' }}></div>
                <h4 className="ms-4 p-2">{patientViewData?.firstName?.toUpperCase() + " " + patientViewData?.lastName?.toUpperCase()}</h4>
                </>
               }
                  {structureViewData &&
               <>
                <h4 className="ms-2 p-2">{structureViewData?.id}</h4>
                <div className="border-end ms-4 mb-1" style={{ height: "1.5rem", borderWidth: "5px",color:'black' }}></div>
                <h4 className="ms-4 p-2">{structureViewData?.name?.toUpperCase()}</h4>
                </>
               }
                </div>
               
                <ul className="custom-tabmenu mt-2">
                    {model.map((item, index) => (
                        <li
                            key={index}
                            className={`tab-item ${activeIndex === index ? "active-tab" : "inactive-tab"}`}
                            onClick={() => setActiveIndex(index)}
                        >
                            <div className={`tab-label-wrapper ${activeIndex === index ? "active-bg" : "inactive-bg"}`}>
                                <h4 className="tab-label">{item.label}</h4>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div
                className="tab-content"
                style={{
                    padding: "20px",
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                }}
            >
                {tabContents[activeIndex]?.content || <div>No content available</div>}
            </div>
        </div>


        </>
    )

}
export default CommonTab;